<template>
	<!-- 应用中心首页 -->
	<v-container fluid class="px-0" style="height: 100%">
		<div class="pb-3" style="width: 100%; height: 100%">
			<v-card class="ma-3" style="height: 100%" elevation="0">
				<v-card-title>
					<v-btn @click="$router.push('/uams/apps')" color="blue" icon><v-icon>mdi-arrow-left</v-icon></v-btn>
					开发中心 <v-spacer />
				</v-card-title>
				<v-toolbar flat color="rgba(0,0,0,0)">
					<v-btn-toggle v-model="btnValue" color="primary" mandatory dense group class="ml-n2">
						<v-btn :value="item.key" class="ml-2" v-for="(item, index) in btnGroup" :key="index" :to="item.url">{{ item.val }}</v-btn>
					</v-btn-toggle>
					<v-spacer></v-spacer>
					<wtk-select
						v-model="queryParam.tags"
						@change="searchQuery"
						placeholder="标签"
						list="disable.acis:三端用户/disable.bizp:服务中枢/disable.comp:组件工具/disable.base:基础支撑/disable.serv:业务支持"
						hide-details
						dense
						outlined
						clearable
						style="max-width: 160px"></wtk-select>
					<v-text-field
						@click:append="searchQuery"
						@keyup.enter="searchQuery"
						v-model="queryParam.condition"
						placeholder="输入接口名称回车后检索"
						append-icon="mdi-magnify"
						class="ml-3"
						hide-details
						outlined
						dense
						clearable
						style="max-width: 350px"></v-text-field>
				</v-toolbar>
				<v-card-text class="pt-0">
					<v-data-table :headers="headers" :items="desserts" :loading="loading" disable-pagination loading-text="数据加载中..." class="elevation-0" hide-default-footer>
						<template v-slot:[`item.idx`]="{ item }">
							<span>{{ desserts.indexOf(item) + 1 }}</span>
						</template>
						<template v-slot:[`item.tags`]="{ item }">
							{{ item?.tags?.match(/^(.*?\.[^.]*?\.).*/)[1] | dict("disable.acis.:三端用户/disable.bizp.:服务中枢/disable.comp.:组件工具/disable.base.:基础支撑/disable.serv.:业务支持") }}
						</template>
						<template v-slot:[`item.name`]="{ item }">
							{{ item.name | txt(18) }}
						</template>
						<template v-slot:[`item.roleIs`]="{ item }">
							<v-chip :color="item.roleIs | dict('0:#ffb90018/1:#2abc3120')" :class="item.roleIs | dict('0:orange--text/1:success--text')" small>
								{{ item.roleIs | dict("0:未授权/1:已授权") }}
							</v-chip>
						</template>
						<template v-slot:[`item.actions`]="{ item }">
							<v-btn color="primary" small text @click="toView(item.id)">查看</v-btn>
						</template>
					</v-data-table>
					<v-divider />
					<pagination :page-sizes="[10, 20]" :page-data="pageData" @pageChange="getListPage" />
				</v-card-text>
			</v-card>
		</div>
	</v-container>
</template>
<script>
import PageMixins from "@/compositions/mixins/pagination";
import Pagination from "@/components/pagination";
import wtkSelect from "@/components/dictionary/WtkSelect";
export default {
	components: { wtkSelect, Pagination },
	mixins: [PageMixins],
	data: () => ({
		loading: true,
		url: { list: "/app/apis/page" },
		headers: [
			{ text: "序号", value: "idx", sortable: false, width: 60 },
			{ text: "标签", value: "tags", sortable: false, width: 200 },
			{ text: "名称", value: "name", sortable: false, width: 300 },
			{ text: "路径", value: "path", sortable: false },
			{ text: "方法", value: "method", sortable: false, width: 70 },
			{ text: "类型", value: "cttype", sortable: false, width: 290 },
			{ text: "状态", value: "roleIs", sortable: false, width: 90 },
			{ text: "操作", value: "actions", sortable: false, width: 90, align: "center" },
		],
		btnGroup: [
			{ key: "1", val: "开发单位", url: "/uams/apps-acid" },
			{ key: "2", val: "开发文档", url: "/uams/apps-docu" },
			{ key: "3", val: "服务接口", url: "/uams/apps-apis" },
			{ key: "0", val: "服务目录", url: "/uams/apps-abiz" },
		],
		btnValue: "0",
		switchState: {
			0: false,
			1: true,
		},
	}),
	activated() {
		this.queryParam.acid = this.$vtk.storage.get("_wit_acis_users").acid;
		this.loadData();
	},
	methods: {
		toView(id) {
			this.$router.push({ path: "/uams/apps-apis-view", query: { apiid: id } });
		},
	},
};
</script>
<style scoped>
::v-deep .v-data-table > .v-data-table__wrapper > table th {
	background: rgba(204, 204, 204, 0.215);
}
</style>
